module.exports = __webpack_public_path__ + "prod/20260929161836/img/shareIcon.d9ffff07.png";